import { IProps } from "../../types/CommonTypes";
import { getImageById, getTextById } from "../../commons/constants/helpers";
import HtmlDescription from "../blogs/HtmlDescription";
import SectionHeader from "../landing/SectionHeader";
import CintaDivider from "../landing/CintaDivider";
import Fade from "react-reveal/Fade";
import "../landing/landing.css";

// ponytail: cifras tomadas de la biografía (Firestore about.description);
// si el cliente actualiza la bio, actualizar aquí.
const STATS = [
	{ number: "+600", label: "Denuncias documentadas con cifras y pruebas" },
	{ number: "+25", label: "Proyectos de Ley radicados" },
	{ number: "+5.000", label: "Ciudadanos formados en el curso gratuito de SECOP" },
	{ number: "+261.000", label: "Votos a la Cámara de Representantes por Bogotá" },
];

export default function About({ item }: IProps) {
	const description = getTextById("description", item);
	const titleArt = getImageById("title", item);

	return (
		<section id="about" className="ld-about">
			<div className="ld-container">
				{titleArt && (
					<Fade>
						<img
							className="ld-about-art"
							src={titleArt}
							alt="Daniel Briceño — Control con verdad"
						/>
					</Fade>
				)}

				<div className="ld-about-content">
					{description && (
						<HtmlDescription
							fontSize={17}
							align="left"
							htmlContent={description}
						/>
					)}
				</div>
			</div>

			<div className="ld-stats">
				<div className="ld-container">
					<SectionHeader
						eyebrow="Control con resultados"
						title="Cifras de mi gestión"
						light
						center
					/>
					<div className="ld-stats-grid">
						{STATS.map((stat) => (
							<div className="ld-stat" key={stat.label}>
								<span className="ld-stat-number">{stat.number}</span>
								<span className="ld-stat-label">{stat.label}</span>
							</div>
						))}
					</div>
				</div>
			</div>
			<CintaDivider />
		</section>
	);
}
